import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { PlayCircle } from "lucide-react";

// Lightweight "See how it works" launcher that opens a captioned walkthrough video.
export const DemoVideo = ({
  src,
  title = "How SimplyRefer works",
  buttonLabel = "See how it works",
  variant = "outline",
  size = "default",
  className = "",
  testId = "demo-video",
}) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button type="button" variant={variant} size={size} className={className} onClick={() => setOpen(true)} data-testid={`${testId}-trigger`}>
        <PlayCircle className="mr-2 h-4 w-4" /> {buttonLabel}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-3xl overflow-hidden bg-white p-0" data-testid={`${testId}-dialog`}>
          <DialogHeader className="px-5 pt-5">
            <DialogTitle className="font-heading text-lg">{title}</DialogTitle>
          </DialogHeader>
          <div className="px-5 pb-5">
            <video
              key={open ? src : "closed"}
              src={src}
              controls
              autoPlay
              muted
              playsInline
              className="aspect-video w-full rounded-md border border-slate-200 bg-black"
              data-testid={`${testId}-player`}
            />
            <p className="mt-2 text-center text-xs text-slate-400">A quick silent walkthrough — captions explain each step.</p>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
